import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { InboxIcon, FolderIcon, SendIcon } from 'lucide-react';

export type Section = {
  folder: string;
  filter: string;
};

export type SidebarProps = {
  onChangeSection: (section: Section) => void;
  currentSection: Section;
  user: {
    folders: string[];
    rules: string[];
  };
};

export const Sidebar: React.FC<SidebarProps> = ({ onChangeSection, currentSection, user }) => {
  const { folder, filter } = currentSection;
  const isInbox = folder === 'inbox';
  const isUnread =  filter === 'unread';
  const isAll = filter === 'all';

  return (
    <div className="h-full w-full md:w-52 border-r bg-white flex flex-col">
      <div className="flex-1 px-4 py-6">
        {/* Unread/All Toggle Pill - only for Inbox */}
      
          <div className="flex overflow-hidden rounded-full border border-gray-300 mb-4">
            <button
              onClick={() => onChangeSection({ ...currentSection, filter: 'unread' })}
              className={`flex-1 py-1 text-xs text-center transition ${
                isUnread ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              Unread
            </button>
            <button
              onClick={() => onChangeSection({ ...currentSection, filter: 'all' })}
              className={`flex-1 py-1 text-xs text-center transition ${
                isAll ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              All
            </button>
          </div>
       

        {/* Inbox Section Label */}
    

        <button                 
          onClick={() => onChangeSection({ ...currentSection, folder: 'inbox'})}
          className={`flex items-center w-full p-2 text-sm rounded transition ${
            folder === 'inbox' ? 'bg-blue-50' : 'hover:bg-gray-100'
          }`}
        >
          <InboxIcon className="h-4 w-4 mr-2" />
          Inbox
        </button>

        {/* Folders Section */}
        {user.folders.length > 0 && (
          <div className="mb-6 ml-3">
            <div className="space-y-1">
              {user.folders.map((folderName: string) => (
                <button
                  key={folderName}
                  onClick={() => onChangeSection({ ...currentSection, folder: folderName})}
                  className={`flex items-center w-full p-2 text-sm rounded transition ${
                    folder === folderName ? 'bg-blue-50' : 'hover:bg-gray-100'
                  }`}
                >
                  <FolderIcon className="h-4 w-4 mr-2" />
                  {folderName}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Sent Section */}
        <button
          onClick={() => onChangeSection({ ...currentSection, folder: 'sent'})}
          className={`flex items-center w-full p-2 text-sm rounded transition ${
            folder === 'sent' ? 'bg-blue-50' : 'hover:bg-gray-100'
          }`}
        >
          <SendIcon className="h-4 w-4 mr-2" />
          Sent
        </button>
      </div>
    </div>
  );
};
